import React, { useState, useEffect } from 'react';
import SectionSelector from './SectionSelector';
import FormInput from './components/FormInput';
import FormTextarea from './components/FormTextarea';
import AddButton from './components/AddButton';
import RemoveButton from './components/RemoveButton';
import WebsiteLinksInput from './components/WebsiteLinksInput';
import CategorizedSkillsInput from './components/CategorizedSkillsInput';
import ExperiencesInput from './components/ExperiencesInput';

const MarketingSpecialistResumeForm = ({ resumeData, onUpdate, validationErrors = {}, onFieldFocus, onFieldBlur, getDynamicSections, renderDynamicSectionForm }) => {
  const [activeSection, setActiveSection] = useState('contact');
  const [newCert, setNewCert] = useState('');
  const [newWebsite, setNewWebsite] = useState("");
  const [newTechnology, setNewTechnology] = useState("");
  // Note: skills input drafts are managed inside CategorizedSkillsInput now
 
 
 
   
 
 
 
 
   const addProject = () => {
     updateField("projects", [...(resumeData.projects || []), {
         title: "",
         name: "", // Keep for compatibility
         description: "",
         link: "",
         year: "",
         technologies: [],
         tech_stack: [], // Add tech_stack for compatibility
         github_link: "" // Add github_link for compatibility
     }]);
   };
 
   const addWebsite = () => {
     if (newWebsite.trim()) {
       updateField("websites", [...(resumeData.websites || []), newWebsite.trim()]);
       setNewWebsite("");
     }
   };
 
   const removeWebsite = (index) => {
     const updatedWebsites = [...(resumeData.websites || [])];
     updatedWebsites.splice(index, 1);
     updateField("websites", updatedWebsites);
   };
 
   const addTechnologyToProject = (projectIndex) => {
     if (newTechnology.trim()) {
       const updatedProjects = [...(resumeData.projects || [])];
       updatedProjects[projectIndex].technologies = [
         ...(updatedProjects[projectIndex].technologies || []),
         newTechnology.trim()
       ];
       updateField("projects", updatedProjects);
       setNewTechnology("");
     }
   };
 
   const updateField = (field, data) => {
     if (field === 'skills') {
       // Updating skills
     }
     if (field === 'projects') {
       // Updating projects
     }
     onUpdate({ ...resumeData, [field]: data });
   };
 
   const handlePersonalChange = (field, value) => {
     onUpdate({ ...resumeData, [field]: value });
   };

  const handleClearAllSkills = () => {
    onUpdate({
      ...resumeData,
      skills: {},
      key_skills: [],
      technical_skills: [],
    });
  };
 
 
 
   const addCert = () => {
     if (newCert.trim()) {
       updateField("certifications", [...(resumeData.certifications || []), newCert.trim()]);
       setNewCert("");
     }
   };
 
   const removeCert = (index) => {
     updateField("certifications", resumeData.certifications.filter((_, i) => i !== index));
   };
 
   const addEducation = () => {
     updateField("education", [...(resumeData.education || []), {
       degree: "",
       field_of_study: "",
       institute: "",
       location: "",
       start_year: "",
       end_year: "",
       graduation_date: "",
       cgpa: ""
     }]);
   };
 
   const updateEducation = (index, field, value) => {
     const updated = [...(resumeData.education || [])];
     updated[index] = { ...updated[index], [field]: value };
     updateField("education", updated);
   };
 
   const removeEducation = (index) => {
     updateField("education", resumeData.education.filter((_, i) => i !== index));
   };
 
   const updateProject = (index, key, value) => {
   const updated = [...resumeData.projects];
   updated[index][key] = value;
     
     // Maintain data consistency across templates
     if (key === 'technologies') {
       updated[index].tech_stack = Array.isArray(value) ? value : value.split(',').map(t => t.trim());
     }
     if (key === 'link') {
       updated[index].github_link = value;
     }
     
   onUpdate({ ...resumeData, projects: updated });
 };
 
   const removeProject = (index) => {
     updateField("projects", resumeData.projects.filter((_, i) => i !== index));
   };
 
  const baseSections = [
     { id: 'contact', label: 'Contact' },
     { id: 'summary', label: 'Summary' },
     { id: 'experience', label: 'Experience' },
     { id: 'skills', label: 'Skills' },
     { id: 'education', label: 'Education' },
     { id: 'certifications', label: 'Certifications' },
     { id: 'projects', label: 'Projects' },
     { id: 'achievements', label: 'Achievements' }
   ];

  // Combine base sections with dynamic sections from ResumeEditor
  const sections = getDynamicSections ? [...baseSections, ...getDynamicSections()] : baseSections;
  const marketingSkills = (resumeData.skills && typeof resumeData.skills === 'object') ? resumeData.skills : {};
  const marketingCategoryKeys = Object.keys(marketingSkills);
  const effectiveMarketingCategories = marketingCategoryKeys.length > 0 ? marketingCategoryKeys : ['Digital Marketing', 'Tools'];
  const categorizedSkillsForUI = {
    ...marketingSkills,
    key_skills: Array.isArray(resumeData.key_skills) ? resumeData.key_skills : [],
    technical_skills: Array.isArray(resumeData.technical_skills) ? resumeData.technical_skills : [],
  };
  const categorizedSkillsCategories = [
    { key: 'key_skills', label: 'Key Skills', placeholder: 'Add key skill...' },
    { key: 'technical_skills', label: 'Technical Skills', placeholder: 'Add technical skill...' },
    ...effectiveMarketingCategories.map((category) => ({
      key: category,
      label: category,
      placeholder: `Add ${category} skill...`,
    })),
  ];
 
 
   return (
     <div className="resume-form" style={{ marginTop: 0, paddingTop: 0 }}>
       <div className="form-content" style={{ marginTop: 0, paddingTop: 0 }}>
         <div className="form-header">
           <h2 className="form-title">Resume Editor</h2>
         </div>
         <SectionSelector
           sections={sections}
           activeSection={activeSection}
           onSectionChange={setActiveSection}
         />
         <div className="section-form">
           {activeSection === 'contact' && (
   <div className="tab-panel">
     <h3 className="section-title">Contact Information</h3>
     <div className="form-group-grid">
 
       <div className={`form-group ${validationErrors.full_name ? 'error' : ''}`}>
         <label>Full Name</label>
         <input
           type="text"
           value={resumeData?.full_name || ""}
           onChange={(e) => handlePersonalChange("full_name", e.target.value)}
           onFocus={() => onFieldFocus && onFieldFocus("full_name")}
           onBlur={() => onFieldBlur && onFieldBlur("full_name")}
           placeholder="Ryan Monroe"
         />
         {validationErrors.full_name && <p className="error-message">{validationErrors.full_name}</p>}
       </div>
 
       <div className={`form-group ${validationErrors.email ? 'error' : ''}`}>
         <label>Email Address</label>
         <input
           type="email"
           value={resumeData?.email || ""}
           onChange={(e) => handlePersonalChange("email", e.target.value)}
           onFocus={() => onFieldFocus && onFieldFocus("email")}
           onBlur={() => onFieldBlur && onFieldBlur("email")}
           placeholder="ryanmonroe47@gmail.com"
           maxLength="60"
         />
         {validationErrors.email && <p className="error-message">{validationErrors.email}</p>}
       </div>
 
       <div className={`form-group ${validationErrors.phone ? 'error' : ''}`}>
         <label>Phone Number</label>
         <input
           type="text"
           value={resumeData?.phone || ""}
           onChange={(e) => handlePersonalChange("phone", e.target.value)}
           onFocus={() => onFieldFocus && onFieldFocus("phone")}
           onBlur={() => onFieldBlur && onFieldBlur("phone")}
           placeholder="+1 (302) 559-2291"
           maxLength="20"
         />
         {validationErrors.phone && <p className="error-message">{validationErrors.phone}</p>}
       </div>
 
       <div className={`form-group ${validationErrors.location ? 'error' : ''}`}>
         <label>Location</label>
         <input
           type="text"
           value={resumeData?.location || ""}
           onChange={(e) => handlePersonalChange("location", e.target.value)}
           onFocus={() => onFieldFocus && onFieldFocus("location")}
           onBlur={() => onFieldBlur && onFieldBlur("location")}
           placeholder="Wilmington, DE"
           maxLength="50"
         />
         {validationErrors.location && <p className="error-message">{validationErrors.location}</p>}
       </div>
 
       <div className={`form-group`}>
         <label>GitHub</label>
         <input
           type="text"
           value={resumeData?.github || ""}
           onChange={(e) => handlePersonalChange("github", e.target.value)}
           placeholder="https://github.com/yourusername"
         />
       </div>
 
       <div className={`form-group`}>
         <label>LinkedIn</label>
         <input
           type="text"
           value={resumeData?.linkedin || ""}
           onChange={(e) => handlePersonalChange("linkedin", e.target.value)}
           placeholder="https://linkedin.com/in/yourprofile"
         />
       </div>
 
       <div className={`form-group`}>
         <label>LeetCode</label>
         <input
           type="text"
           value={resumeData?.leetcode || ""}
           onChange={(e) => handlePersonalChange("leetcode", e.target.value)}
           placeholder="https://leetcode.com/yourusername"
         />
       </div>
 
       <div className={`form-group`}>
         <label>HackerRank</label>
         <input
           type="text"
           value={resumeData?.hackerrank || ""}
           onChange={(e) => handlePersonalChange("hackerrank", e.target.value)}
           placeholder="https://www.hackerrank.com/yourusername"
         />
       </div>
 
     </div>
 
     <WebsiteLinksInput
       websites={resumeData.websites || []}
       newWebsite={newWebsite}
       setNewWebsite={setNewWebsite}
       onAdd={addWebsite}
       onRemove={removeWebsite}
     />
   </div>
 )}
 
           
 
 
           {activeSection === 'summary' && (
   <div className="tab-panel">
     <h3 className="section-title">Professional Summary</h3>
     <div className={`form-group ${validationErrors.professional_summary ? 'error' : ''}`}>
       <textarea
         value={resumeData?.professional_summary || ""}
         onChange={(e) => updateField("professional_summary", e.target.value)}
         onFocus={() => onFieldFocus && onFieldFocus("professional_summary")}
         onBlur={() => onFieldBlur && onFieldBlur("professional_summary")}
         placeholder="e.g. Results-focused AI/ML engineer with proven experience..."
         rows={6}
         maxLength="1000"
       />
       {validationErrors.professional_summary && (
         <p className="error-message">{validationErrors.professional_summary}</p>
       )}
     </div>
   </div>
 )}
 
 
 {activeSection === 'experience' && (
   <div className="tab-panel">
     <ExperiencesInput
       experiences={resumeData.relevant_experience}
       onChange={(updated) => updateField("relevant_experience", updated)}
       errors={validationErrors.relevant_experience}
       onFieldFocus={onFieldFocus}
       onFieldBlur={onFieldBlur}
       title="Relevant Experience"
       addLabel="Add Experience"
       positionPlaceholder="Director of Operations"
       companyPlaceholder="The Ultimate Shave"
       locationPlaceholder="Glenn Mills, PA"
       startDatePlaceholder="2021-10"
       endDatePlaceholder="Present"
       pointsPlaceholder="Describe your responsibilities..."
       positionMaxLength={70}
       companyMaxLength={70}
       locationMaxLength={50}
       startDateMaxLength={20}
       endDateMaxLength={20}
       pointsMaxLength={300}
     />
   </div>
 )}
 
 {activeSection === 'education' && (
   <div className="tab-panel">
     <div className="section-header">
       <h3 className="section-title">Education</h3>
       <button onClick={addEducation} className="add-button">+ Add Education</button>
     </div>
     {(resumeData.education || []).map((edu, index) => {
       const eduErrors = validationErrors.education?.[index] || {};
       return (
         <div key={index} className="education-card">
           <div className="card-header">
             <h4>Education {index + 1}</h4>
             <button onClick={() => removeEducation(index)} className="remove-button">🗑️</button>
           </div>
           <div className="card-content">
 
             <div className="form-group">
               <label>Degree</label>
               <input 
                 type="text"
                 value={edu.degree || ""}
                 onChange={(e) => updateEducation(index, "degree", e.target.value)}
                 placeholder="Bachelor of Technology"
               />
             </div>
 
             <div className="form-group">
               <label>Field of Study</label>
               <input 
                 type="text"
                 value={edu.field_of_study || ""}
                 onChange={(e) => updateEducation(index, "field_of_study", e.target.value)}
                 placeholder="Electronics and Communication Engineering"
               />
             </div>
 
             <div className="form-group">
               <label>Institute</label>
   <input 
     type="text"
     value={edu.institute || ""}  // ✅ Correct key
     onChange={(e) => updateEducation(index, "institute", e.target.value)}  // ✅ Correct update path
     placeholder="Siddhartha Institute of Technology and Sciences"
   />
             </div>
 
             <div className="form-group">
               <label>Location</label>
               <input 
                 type="text"
                 value={edu.location || ""}
                 onChange={(e) => updateEducation(index, "location", e.target.value)}
                 placeholder="Hyderabad, Telangana"
               />
             </div>
 
             <div className="form-group-grid">
               <div className="form-group">
                 <label>Start Year</label>
                 <input 
                   type="text"
                   value={edu.start_year || ""}
                   onChange={(e) => updateEducation(index, "start_year", e.target.value)}
                   placeholder="2020"
                 />
               </div>
               <div className="form-group">
                 <label>End Year</label>
                 <input 
                   type="text"
                   value={edu.end_year || ""}
                   onChange={(e) => updateEducation(index, "end_year", e.target.value)}
                   placeholder="2024"
                 />
               </div>
             </div>
 
             <div className="form-group">
               <label>CGPA</label>
               <input 
                 type="text"
                 value={edu.cgpa || ""}
                 onChange={(e) => updateEducation(index, "cgpa", e.target.value)}
                 placeholder="7.09/10"
               />
             </div>
 
           </div>
         </div>
       );
     })}
   </div>
 )}
 
 
 {activeSection === 'certifications' && (
   <div className="tab-panel">
     <h3 className="section-title">Certifications</h3>
     <div className="add-skill">
       <input
         type="text"
         value={newCert}
         onChange={(e) => setNewCert(e.target.value)}
         placeholder="Add a certification"
         maxLength="100"
       />
       <button onClick={addCert}>Add</button>
     </div>
     <div className="skills-list">
       {(resumeData.certifications || []).map((cert, index) => (
         <span key={index} className="skill-tag">
           <span>
             {typeof cert === 'string' ? cert : (cert.name || cert)}
             {typeof cert === 'object' && cert.provider ? ` – ${cert.provider}` : ""}
           </span>
           <button onClick={() => removeCert(index)}>×</button>
         </span>
       ))}
     </div>
   </div>
 )}
 
 
 {activeSection === 'skills' && (
  <div className="tab-panel">
    <div className="section-header">
      <h3 className="section-title">Skills</h3>
    </div>
    <CategorizedSkillsInput
      skills={categorizedSkillsForUI}
      onClear={handleClearAllSkills}
      clearLabel="Clear"
      onChange={(updated) => {
        const nextKeySkills = Array.isArray(updated.key_skills) ? updated.key_skills : [];
        const nextTechnicalSkills = Array.isArray(updated.technical_skills) ? updated.technical_skills : [];

        const nextMarketingSkills = { ...(marketingSkills || {}) };
        effectiveMarketingCategories.forEach((category) => {
          nextMarketingSkills[category] = Array.isArray(updated[category]) ? updated[category] : [];
        });

        onUpdate({
          ...resumeData,
          key_skills: nextKeySkills,
          technical_skills: nextTechnicalSkills,
          skills: nextMarketingSkills,
        });
      }}
      categories={categorizedSkillsCategories}
    />
  </div>
)}
 
 
 {activeSection === 'achievements' && (
   <div className="tab-panel">
     <div className="section-header">
       <h3 className="section-title">Achievements</h3>
       <button onClick={() => updateField("achievements", [...(resumeData.achievements || []), ""])} className="add-button">
         + Add Achievement
       </button>
     </div>
     {(resumeData.achievements || []).map((item, index) => (
       <div key={index} className="form-group" style={{ display: 'flex', gap: '10px' }}>
         <input
           type="text"
           value={item}
           onChange={(e) => {
             const updated = [...resumeData.achievements];
             updated[index] = e.target.value;
             updateField("achievements", updated);
           }}
           placeholder="E.g., GATE Qualified - 97.43 percentile"
         />
         <button onClick={() => {
           const updated = resumeData.achievements.filter((_, i) => i !== index);
           updateField("achievements", updated);
         }}>🗑️</button>
       </div>
     ))}
   </div>
 )}
 
 
 {activeSection === 'projects' && (
   <div className="tab-panel">
     <div className="section-header">
       <h3 className="section-title">Projects</h3>
       <button onClick={addProject} className="add-button">+ Add Project</button>
     </div>
     {(resumeData.projects || []).map((proj, index) => (
       <div key={index} className="experience-card">
         <div className="card-header">
           <h4>Project {index + 1}</h4>
           <button onClick={() => removeProject(index)} className="remove-button">🗑️</button>
         </div>
         <div className="card-content">
           <div className="form-group">
             <label>Title</label>
             <input
               type="text"
               value={proj.title || ''}
               onChange={(e) => updateProject(index, "title", e.target.value)}
               placeholder="Project Title"
             />
           </div>
           <div className="form-group">
             <label>Description</label>
             <textarea
               value={proj.description || ''}
               onChange={(e) => updateProject(index, "description", e.target.value)}
               placeholder="A short description of your project."
               rows={3}
             />
           </div>
           <div className="form-group">
             <label>Link</label>
             <input
               type="text"
               value={proj.link || ''}
               onChange={(e) => updateProject(index, "link", e.target.value)}
               placeholder="https://github.com/your/project"
             />
           </div>
           <div className="form-group">
     <label>Year</label>
     <input
       type="text"
       value={proj.year || ""}
       onChange={(e) => updateProject(index, "year", e.target.value)}
       placeholder="2025"
     />
   </div>
           <div className="form-group">
             <label>Technologies (comma separated)</label>
             <input
               type="text"
               value={Array.isArray(proj.technologies) ? proj.technologies.join(', ') : ''}
               onChange={(e) => {
                 const updated = [...(resumeData.projects || [])];
                 const technologies = e.target.value.split(',').map(t => t.trim()).filter(t => t);
                 updated[index] = { 
                   ...proj, 
                   technologies: technologies,
                   tech_stack: technologies // Ensure tech_stack is also updated
                 };
                 updateField("projects", updated);
               }}
               placeholder="React, Node.js, Firebase"
             />
           </div>
         </div>
       </div>
     ))}
   </div>
 )}
 
          {/* DYNAMIC SECTIONS - Rendered from ResumeEditor.jsx */}
          {renderDynamicSectionForm && getDynamicSections && getDynamicSections().map(section => {
            if (activeSection === section.id) {
              return renderDynamicSectionForm(section.id);
            }
            return null;
          })}
           
   
         </div>
       </div>
     </div>
   );
 } 
  
 
export default MarketingSpecialistResumeForm;
